<template>
  <div id="contentAreaHeight">
    
    <div class="main-banner"
        v-for="(banner, index) in banners"
        :key="banner.BannerID"
        :style="{height: banner.HeightSize + '48'}">
        <a :href="banner.LinkUrl" target="_blank">
            <img :src="getApiUrl() + '/' + banner.FileUrl" :alt="banner.Title">
        </a>
        <div class="banner-bottom">
            <button @click="closeBanner(index)">닫기</button>
            <button @click="setCookie(index)">오늘 다시보지 않기</button>
        </div>
    </div>
    
    <!-- <Banner></Banner> -->

    <div class="wrap-content section-content contentAreaHeight">

        <article class="article">
            <div class="container-full">
                <div class="row">
                    <div class="col">

                        <section class="section">
                            <div class="text-center">
                                <carousel
                                    :perPage="1"
                                    :autoplay="true"
                                    :loop="true"
                                    :scrollPerPage="false"
                                    :paginationEnabled="false"
                                    :autoplayTimeout="4000"
                                >
                                    <!-- <slide>

                                        <div class="slide1">
                                            <a href="#"> <button class="btn1" type="button"><b>가맹문의 바로가기</b></button></a>
                                            <img src="/img/main/landing-230508-slide1.png" class="img w-100 " alt="">
                                        
                                        </div>
                                    </slide> -->
                                    <slide>
                                        <div class="slide2">
                                            <!-- <a href="#"> <button class="btn2" type="button"><b>자세히 보기</b></button></a> -->
                                            <img src="/img/main/landing-230508-slide2.png" class="img w-100 " alt="">
                                        </div>
                                        <!-- <map name="map-1">
                                            <area shape="rect" coords="1292,827,1585,872" href="/franchisee"/>
                                        </map> -->
                                    </slide>
                                    <!-- <slide>
                                        <img src="/img/main/landing-220404-01-3.jpg" class="img w-100" alt="">
                                    </slide>
                                    <slide>
                                        <img src="/img/main/landing-220404-01-4.jpg" class="img w-100" alt="">
                                    </slide> -->
                                </carousel>
                            </div>
                        </section>

                        <section class="section" id="section-2">
                            <div class="text-center section2-bg">
                                <img src="/img/main/landing-230508-01.png" class="img w-100 " alt="">
                            </div>
                        </section>

                    </div> <!-- /.col -->
                </div> <!-- /.row -->
            </div> <!-- /.container -->

            <section class="section03"  id="section-3" style="overflow-x: auto; -ms-overflow-style: none;">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="section-title">
                                    초등학생이 겁없이 푸는 대입 수능</div>
                            <div class="card-wrap">
                                    <div class="card">
                                        <div class="card-video">
                                            <div class="video-veil-sm">
                                                <video 
                                                    :src="getApiUrl() + '/video/promotion/video-3.mp4'"
                                                    poster="/img/poster/poster-3.png" 
                                                    controls 
                                                    controlsList="nodownload" 
                                                    width="100%"
                                                    height="100%" ></video>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <h5 class="card-title">수학여우 문제풀이</h5>
                                            <p class="card-text">
                                                수학은 언어다 도형편 1권<br/>
                                                이등변삼각형의 성질을 이용한 문제풀이
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="card">
                                        <div class="card-video">
                                            <div class="video-veil-sm">
                                                <iframe 
                                                    width="100%" 
                                                    height="100%" 
                                                    src="https://www.youtube.com/embed/rrPLRjmaAhI"
                                                    frameborder="0" 
                                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                                    allowfullscreen></iframe>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <h5 class="card-title">미분 수능 문제풀이</h5>
                                            <p class="card-text">
                                                제1회 수학여우 문제풀이 영상콘테스트
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-video">
                                            <div class="video-veil-sm">
                                                <video 
                                                    :src="getApiUrl() + '/video/promotion/StudentExplain-1.mp4'"
                                                    poster="/img/poster/StudentExplainPoster-1.png"
                                                    controls 
                                                    controlsList="nodownload" 
                                                    width="100%"
                                                    height="100%" ></video>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <h5 class="card-title">초등학생 극한 수능 문제풀이</h5>
                                            <p class="card-text">
                                                 초등학생 극한 수능 문제풀이
                                            </p>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section" id="section-5">

                <section class="section section4-1-bg">
                    <div class="text-center">
                        <img src="/img/main/landing-230508-03.png" class="img w-100" alt="">
                    </div>
                </section>
                <div class="text-center section4-2-bg">
                    <img src="/img/main/landing-230508-04.png" class="img w-100" alt="">
                </div>
                <div class="text-center section4-3-bg">
                    <img src="/img/main/landing-230508-05.png" class="img w-100" alt="">
                </div>
            </section>

            <section class="section05"  id="section-4" >
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="section-title">INTERVIEW: 수학여우 원장님 & 선생님</div>
                            <div class="card-wrap">
                                    <div class="card">
                                        <div class="card-video">
                                            <div class="video-veil-sm">
                                                <video 
                                                    :src="getApiUrl() + '/video/promotion/interview-1.mp4'"
                                                    poster="/img/poster/interview-1.jpg"
                                                    controls 
                                                    controlsList="nodownload" 
                                                    width="100%"
                                                    height="100%" ></video>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="card">
                                        <div class="card-video">
                                            <div class="video-veil-sm">
                                                <video 
                                                    :src="getApiUrl() + '/video/promotion/interview-2.mp4'"
                                                    poster="/img/poster/interview-2.jpg"
                                                    controls 
                                                    controlsList="nodownload" 
                                                    width="100%"
                                                    height="100%" ></video>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- <section class="section">
                <div class="text-center">
                    <img src="/img/main/landing-220404-05-1.jpg" class="img w-100" alt="">
                </div>
            </section> -->

            <section class="section">
                <div class="text-center section7-bg">
                    <img src="/img/main/landing-230508-07.png" class="img w-100" alt="">
                </div>
            </section>

            <!-- <section class="section">
                <div class="text-center">
                    <img src="/img/main/landing-220404-07.jpg" class="img w-100" alt="">
                </div>
            </section> -->

            <!-- <section class="section05">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="section-title">
                                수학여우 홍보영상
                            </div>
                            <div class="video-player">
                                <iframe width="100%" height="100%" 
                                    src="https://www.youtube.com/embed/ZJYd1UrqKQw" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->

            <section class="section-bg">

                <!-- <section class="section09">
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <div class="d-flex">
                                    <div class="section-title">
                                        수학여우 체험후기
                                    </div>
                                    <div class="d-flex ml-4 font-size-125 mt-2 text-secondary">
                                        <div class="mt-2">더보기</div>
                                        <div class="ml-1 mt-1 font-size-125">
                                            <i class="fas fa-plus-circle"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="card mt-5 p-5">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th class="no">글번호</th>
                                            <th class="title text-center">제목</th>
                                            <th class="writer">글쓴이</th>
                                            <th class="date">날짜</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="no">4</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">3</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">2</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">1</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> -->

                <!-- <section class="section10">
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <div class="d-flex">
                                    <div class="section-title">
                                        수학여우 이모저모
                                    </div>
                                    <div class="d-flex ml-4 font-size-125 mt-2 text-secondary">
                                        <div class="mt-2">더보기</div>
                                        <div class="ml-1 mt-1 font-size-125">
                                            <i class="fas fa-plus-circle"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="card mt-5 p-5">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th class="no">글번호</th>
                                            <th class="title text-center">제목</th>
                                            <th class="writer">글쓴이</th>
                                            <th class="date">날짜</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td class="no">4</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">3</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">2</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        <tr>
                                            <td class="no">1</td>
                                            <td class="title">
                                                <a href="#" class="ellipse">
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                    공지사항 제목이 들어갈 부분입니다. 최대 길이로 작성될 경우 끝 부분이 일부 생략 수 있습니다.
                                                </a>
                                            </td>
                                            <td class="writer">류연우 박사</td>
                                            <td class="date">2019-09-15</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> -->

            </section>
        </article>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from '@/components/Banner.vue'
import qs from 'qs';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: 'home',
    components: {
        Banner,
        Carousel,
        Slide
    },
    data() {
        return {
            banners: [],
            businessForm: {
                name: '',
                region: '',
                career: '',
                from: '',
                phone: '',
                email: ''
            },
            businessError: {
                name: '',
                phone: ''
            },
            parentsForm: {
                name: '',
                student: '',
                school: '',
                address: '',
                phone: '',
                email: ''
            },
            parentError: {
                name: '',
                phone: ''
            },
        }
    },
    created() {
        this.getBanner();
    },
    methods: {
        getBanner () {
            this.axios.get(process.env.VUE_APP_API + '/api/banners')
            .then(response => {
                let banners = response.data
                for (let index = 0; index < banners.length; index++) {
                    if(this.getCookie( 'banner-' + banners[index].BannerID )) banners.splice(index, 1) 
                }
                this.banners = banners
            })
        },
        sendBusiness (event) {
            if ( !confirm('전송 하시겠습니까?') ) return false 
            event.target.disabled = true
            this.axios.post(process.env.VUE_APP_API + '/api/mail-business', qs.stringify(this.businessForm))
            .then(response => {
                console.log(response.data)
                alert('전송 되었습니다.')
                this.businessForm = {
                    name: '',
                    region: '',
                    career: '',
                    from: '',
                    phone: '',
                    email: ''
                }
                event.target.disabled = false
            })
            .catch(error => {
                console.log(error.response)
                if (error.response.status === 422) {
                    var valiErrs = error.response.data.errors
                    var valiErrKeys = Object.keys(valiErrs)
                    var errKeys = Object.keys(this.businessError)

                    for (let index = 0; index < errKeys.length; index++) {
                        if (valiErrKeys.indexOf(errKeys[index]) == -1) {
                            this.businessError[errKeys[index]] = false
                        } else {
                            this.businessError[errKeys[index]] = valiErrs[errKeys[index]][0]
                        }
                    }
                } else {
                    alert(error.response.statusText)
                    console.log(error.response)
                }
                event.target.disabled = false
            })
        },
        sendParents (event) {
            if ( !confirm('전송 하시겠습니까?') ) return false 
            event.target.disabled = true
            this.axios.post(process.env.VUE_APP_API + '/api/mail-parents', qs.stringify(this.parentsForm))
            .then(response => {
                console.log(response.data)
                alert('전송 되었습니다.')
                this.parentsForm = {
                    name: '',
                    student: '',
                    school: '',
                    address: '',
                    phone: '',
                    email: ''
                }
                event.target.disabled = false
            })
            .catch(error => {
                console.log(error.response)
                if (error.response.status === 422) {
                    var valiErrs = error.response.data.errors
                    var valiErrKeys = Object.keys(valiErrs)
                    var errKeys = Object.keys(this.parentError)

                    for (let index = 0; index < errKeys.length; index++) {
                        if (valiErrKeys.indexOf(errKeys[index]) == -1) {
                            this.parentError[errKeys[index]] = false
                        } else {
                            this.parentError[errKeys[index]] = valiErrs[errKeys[index]][0]
                        }
                    }
                } else {
                    alert(error.response.statusText)
                    console.log(error.response)
                }
                event.target.disabled = false
            })
        },
        getApiUrl () {
            return process.env.VUE_APP_API
        },
        closeBanner(index) {
            this.banners.splice(index, 1)
        },
        setCookie (index) {
            let date = new Date()
            let exp = 1
            let name = 'banner-' + this.banners[index].BannerID
            date.setTime(date.getTime() + exp*24*60*60*1000)
            document.cookie = name + '=true;expires=' + date.toUTCString() + ';path=/'
            this.closeBanner(index)
        },
        getCookie (name) {
            let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
            return value ? value[2] : null
        },
        gotoFranchisee () {
            window.location.href = "/franchisee";
        }
    }
}
</script>

